<header class="header">
  <div class="container">
    <div class="header__col logo-col">
      <a href="#" class="logo">
        <img class="logo__item" width="154px" height="84" src="./assets/img/logo@2x.png" alt="עיריית תל אביב יפו" />
      </a>
    </div>
    <div class="header__col text-col">
      <span role="none" class="header__text">ברוך בואך לדיגיתל שלי לעסקים</span>
    </div>
  </div>
</header>